<template>
  <div class="left-menu">
   <el-menu
      :default-active="active"
      @select="onSelect">
      <span v-for="(item,index) in list" :key="index">
          <template v-if="item.children && item.children.length">
            <el-submenu :index="item.name">
              <template slot="title">
                <i :class="item.meta.icon"></i>
                <span>{{item.meta.title}}</span>
              </template>
              <span v-for="(son,sonIndex) in item.children" :key="sonIndex">
                  <template v-if="son.meta.show">
                     <el-menu-item :index="son.name">{{son.meta.title}}</el-menu-item>
                  </template>
              </span>
            </el-submenu>
          </template>
          <template v-else>
             <el-menu-item :index="item.name">
              <i class="el-icon-menu"></i>
              <span slot="title">{{item.meta.title}}</span>
            </el-menu-item>
          </template>
      </span>
   </el-menu>
  </div>
</template>

<script>
export default {
  name: 'leftMenu',
  props:{
    list:{
      type:Array,
      default:()=>{
        return []
      }
    },
    active:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      defaultActive:""
    }
  },
  created(){
    this.defaultActive = this.active
  },
  methods:{
    onSelect(index){
      this.defaultActive = index
      let path = '/'+index.replace("-","/")
      this.$router.push({ path})
    }
  }
}
</script>

<style scoped>
.left-menu{
  width: 204px;
  height: calc(100vh - 56px);
  min-height: 800px;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/left-menu/index.vue